import {
    handleFloat,
    handleBool,
    Color,
    PixelObject,
    Base
} from "../index.js"

export default class Line extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'LINE',
            name: 'Line',
            x: 0,
            y: 0,
            x2: 50,
            y2: 50,
            width: 200,
            height: 100,
            strokes: [new Color({ parent: this })],
            fills: [],
            modifiers: [],
            placeOnPath: true
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name

        this.width = opts.width
        this.height = opts.height

        this.x = opts.x
        this.y = opts.y

        this.x2 = opts.x2
        this.y2 = opts.y2
        this.strokes = opts.strokes
        this.fills = opts.fills
        this.modifiers = opts.modifiers

        this.placeOnPath = opts.placeOnPath

        this.count = 100

        if (this.modifiers.length > 0) {
            this.createBuffer()
        }
    }

    set(key, newValue) {
        let config = {
            placeOnPath: handleBool,
            x2: handleFloat,
            y2: handleFloat,
        }

        if (config[key]) {
            const oldValue = this[key]
            let parsedValue = config[key]({ newValue, oldValue })
            if (oldValue != parsedValue) {
                this[key] = parsedValue
                this.dispatchToParent('objectStateChanged', this.propertyChangedMessage(key))
            }
        } else {
            PixelObject.prototype.set.call(this, key, newValue)
        }
    }

    copy(args) {
        return new Line({ ...this, ...args, modifiers: [], buffer: null, skipParentGeneration: true })
    }

    renderBuffer() {
        console.log("Line regenerating")

        const self = this

        this.buffer.clear()

        for (let count = 0; count < this.count; count++) {

            const element = this.copy()
            element.ctx = this.buffer
            this.modifiers.forEach(modifier => {
                modifier.apply({ element, count, width: self.width, height: self.height, placeOnPath: self.placeOnPath })
            })

            element.draw()
        }

        this.stop = false
    }

    draw() {
        if (this.visible == '0' || this.deleted || this.opacity == 0) return

        this.ctx.push()

        this.fill()
        this.stroke()

        let x = this.getRenderPositionProperty('x')
        let y = this.getRenderPositionProperty('y')
        let x2 = this.getRenderPositionProperty('x2')
        let y2 = this.getRenderPositionProperty('y2')

        if (this.buffer) {
            if (!this.stop) {
                this.stop = true
                this.image = this.buffer.createImage(this.ctx.width, this.ctx.height)
                this.image.copy(this.buffer, 0, 0, this.ctx.width, this.ctx.height, 0, 0, this.ctx.width, this.ctx.height)
            }
            if (this.image) {
                if (this.rotate) {
                    this.ctx.translate(this.width / 2, this.height / 2)
                    this.ctx.rotate(this.ctx.radians(this.rotate))
                    this.ctx.image(this.image, -this.width / 2, -this.height / 2);
                } else {
                    this.ctx.translate(this.x, this.y)

                    if (this.opacity !== 100) {
                        this.ctx.tint(255, 255 / 100 * this.opacity)
                    }

                    this.ctx.image(this.image, 0, 0);
                }
            }
        } else {
            this.ctx.line(x, y, x2, y2);
        }

        this.ctx.pop()
    }
}